<template>
    <el-dialog v-dialogDrag width="700px" :title="title" :visible.sync="setDatasourceVisible" :append-to-body="true"
        :before-close="handleClose" class="dataroom-el-dialog">
        <div v-loading="linkLoading" element-loading-text="正在测试连接...">
            <el-form ref="dataForm" class="bs-el-form" :model="dataForm" :rules="updateRules" size="small"
                label-position="right" :label-width="dataForm.advanceSettingFlag ? '200px' : '100px'">
                <el-row v-if="type != 2">
                    <el-col :span="12">
                        <el-form-item class="bselformitem" label="类型" prop="type">
                            <el-select v-model="dataForm.type" placeholder="请选择类型" class="bs-el-select" clearable filterable
                                @change="sourceTypeChange">
                                <el-option v-for="sourceType in sourceTypeList" :key="sourceType.code"
                                    :label="sourceType.dictionary_value" :value="sourceType.dictionary_key" />
                            </el-select>
                        </el-form-item>
                        <el-form-item class="bselformitem" label="IP" prop="ip">
                            <el-input v-model="dataForm.ip" placeholder="请输入IP" class="bs-el-input" maxlength="200" />
                        </el-form-item>
                        <el-form-item class="bselformitem" label="用户名" prop="username">
                            <el-input v-model="dataForm.username" placeholder="请输入用户名" class="bs-el-input" />
                        </el-form-item>
                        <el-form-item class="bselformitem" label="备注" prop="description">
                            <el-input v-model="dataForm.description" placeholder="请输入备注" class="bs-el-input"
                                maxlength="200" />
                        </el-form-item>

                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="数据源名称" prop="name">
                            <el-input v-model="dataForm.name" placeholder="请输入数据源名称" class="bs-el-input" maxlength="200" />
                        </el-form-item>
                        <el-form-item label="端口" prop="port">
                            <el-input v-model="dataForm.port" placeholder="请输入端口" class="bs-el-input" maxlength="200" />
                        </el-form-item>
                        <el-form-item label="密码" prop="password">
                            <el-input autocomplete="new-password" v-model="dataForm.password"
                                :placeholder="dataForm.id ? '请输入密码，不输入代表不更新' : '请输入密码'" class="bs-el-input" type="password"
                                show-password />
                        </el-form-item>
                        <el-form-item label="所属企业" prop="enterprise">
                            <el-select class="bs-el-select" v-model="dataForm.enterprise" placeholder="请选择企业">
                                <el-option-group v-for="(group, index) in options" :key="index" :label="group.label">
                                    <el-option v-for="(item, index) in group.options" :key="index"
                                        :label="item.enterprise_name" :value="item.enterprise_id"></el-option>
                                </el-option-group>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item v-else class="bselformitem" label="数据库" prop="databaseName">
                    <el-select v-model="dataForm.databaseName" placeholder="请选择类型" class="bs-el-select" clearable filterable
                        @change="sourceTypeChange">
                        <el-option v-for="sourceType in databaseTypeList" :key="sourceType.code" :label="sourceType"
                            :value="sourceType" />
                    </el-select>
                </el-form-item>
                <template v-if="dataForm.advanceSettingFlag">
                    <el-form-item label="初始化连接数">
                        <el-input v-model="dataForm.initConnNum" />
                    </el-form-item>
                    <el-form-item label="最大活动连接数">
                        <el-input v-model="dataForm.maxActiveConnNum" />
                    </el-form-item>
                    <el-form-item label="最大空闲连接数">
                        <el-input v-model="dataForm.maxIdleConnNum" />
                    </el-form-item>
                    <el-form-item label="最小空闲连接数">
                        <el-input v-model="dataForm.minIdleConnNum" />
                    </el-form-item>
                    <el-form-item label="最大等待时间 (ms)">
                        <el-input v-model="dataForm.maxWaitConnNum" />
                    </el-form-item>
                    <el-form-item label="SQL验证查询">
                        <el-input v-model="dataForm.sqlCheck" type="text" />
                    </el-form-item>
                    <el-form-item label="获取连接前校验">
                        <el-select v-model="dataForm.getconnCheckFlag" clearable>
                            <el-option label="是" :value="1" />
                            <el-option label="否" :value="0" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="归还连接前校验">
                        <el-select v-model="dataForm.returnCheckFlag" clearable>
                            <el-option label="是" :value="1" />
                            <el-option label="否" :value="0" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="开启空闲回收器校验">
                        <el-select v-model="dataForm.startIdleCheckFlag" clearable>
                            <el-option label="是" :value="1" />
                            <el-option label="否" :value="0" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="空闲连接回收器休眠时间 (ms)">
                        <el-input v-model="dataForm.idleConnDormantTime" />
                    </el-form-item>
                    <el-form-item label="空闲连接回收检查数">
                        <el-input v-model="dataForm.idleConnCheckNum" />
                    </el-form-item>
                    <el-form-item label="保持空闲最小时间值 (s)">
                        <el-input v-model="dataForm.keepIdleMinTime" />
                    </el-form-item>
                </template>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button v-if="type != 2" type="primary" @click="sourceLinkCheck">
                测试
            </el-button>
            <el-button class="bs-el-button-default" @click="handleClose">
                取消
            </el-button>
            <el-button type="primary" @click="submitForm">
                确定
            </el-button>
        </span>
    </el-dialog>
</template>

<script>

export default {
    props: {
    },
    data() {
        return {
            setDatasourceVisible: false,
            title: '',
            linkLoading: false,
            dataForm: {
                id: '',
                name: '',
                type: '1',
                driverClassName: 'com.mysql.jdbc.Driver',
                username: '',
                password: '',
                ip: '',
                port: '',
                enterprise: '',
                description: ''
            },
            rules: {
                type: [
                    { required: true, message: '请选择数据源类型', trigger: 'blur' }
                ],
                name: [
                    { required: true, message: '请输入数据源名称', trigger: 'blur' },
                ],
                driverClassName: [
                    { required: true, message: '请选择连接驱动', trigger: 'blur' }
                ],

                database: [
                    { required: true, message: '请输入数据库名称', trigger: 'blur' },
                    { pattern: /^[^\u4e00-\u9fa5]+$/, message: '数据库名称不能包含汉字' }
                ],
                host: [
                    { required: true, message: '请输入主机号', trigger: 'blur' },
                    {
                        pattern: /((25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))\.){3}(25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))/,
                        message: '主机号格式有误'
                    }
                ],
                port: [
                    { required: true, message: '请输入端口', trigger: 'blur' },
                    { pattern: /^[0-9]*$/, message: '端口号只能为数字' }
                ],
                username: [
                    { required: true, message: '请输入用户名', trigger: 'blur' },
                    { pattern: /^[^\u4e00-\u9fa5]+$/, message: '用户名不能包含汉字' }
                ],

                coding: [
                    { required: true, message: '请选择编码', trigger: 'blur' }
                ]
            },
            updateRules: {
                type: [
                    { required: true, message: '请选择数据源类型', trigger: 'blur' }
                ],
                name: [
                    { required: true, message: '请输入数据源名称', trigger: 'blur' },
                ],
                ip: [
                    { required: true, message: '请输入IP', trigger: 'blur' },
                    { pattern: /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.{1,2}){2}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/, message: '请输入正确的ip地址' }
                ],
                port: [
                    { required: true, message: '请输入端口', trigger: 'blur' },
                    { pattern: /^[0-9]*$/, message: '端口号只能为数字' }
                ],
                username: [
                    { required: true, message: '请输入用户名', trigger: 'blur' },
                    { pattern: /^[^\u4e00-\u9fa5]+$/, message: '用户名不能包含汉字' }
                ],
                enterprise: [
                    { required: true, message: '请选择所属企业', trigger: 'blur' }
                ],
                password: [
                    { required: true, message: '请输入密码', trigger: 'blur' }
                ],
            },
            sourceTypeList: [],
            databaseTypeList: [],
            options: JSON.parse(localStorage.getItem("entinfolist")),
            type: '',
        }
    },
    methods: {
        bycodelist(code, type) {
            this.$tools
                .asyncPost(this, this.$baseUrl.dictinfogetbycode, {
                    data: {
                        dictionary_code: code
                    }
                })
                .then(res => {
                    if (res.data.code == 0) {
                        switch (type) {
                            case 1:
                                this.sourceTypeList = res.data.data.dictionary_detail;
                                break;
                            default:
                                break;
                        }
                    } else {
                        this.$message({ type: "error", message: res.data.msg });
                    }
                })
                .catch(err => { });
        },
        // 初始化
        init(row, type) {
            // 清除表单验证
            if (this.$refs.dataForm) {
                this.$refs.dataForm.clearValidate()
            }
            if (row && row.id) {
                this.dataForm = row
                // console.log(this.dataForm);
            }
            this.bycodelist('BS-DATASOURCE', 1)
            this.type = type
            if (type == 2) {
                this.$tools
                    .asyncPost(this, this.$baseUrl.getMysqlDatabase, {
                        data: {
                            id: row.id
                        }
                    })
                    .then(res => {
                        if (res.data.code == 0) {
                            this.databaseTypeList = res.data.data
                        } else {
                            this.$message({ type: "error", message: res.data.msg });
                        }
                    })
                    .catch(err => { });
            }

        },
        // 数据源类型选择
        sourceTypeChange(code) {
            if (!this.dataForm.id && code) {
                this.dataForm.driverClassName = this.sourceTypeList.find(item => item.code === code)?.name
                this.$set(this.dataForm, 'url', this.sourceTypeList.find(item => item.code === code)?.url)
            }
        },
        // 阻止文本域回车换行
        textareaKeydown() {
            const e = window.event || arguments[0]
            if (e.key === 'Enter' || e.code === 'Enter' || e.keyCode === 13) {
                e.returnValue = false
                return false
            }
        },
        // 连接测试
        sourceLinkCheck() {
            let flag = 0
            this.$refs.dataForm.validate((valid) => {
                if (!valid) {
                    flag = 1
                    return false
                } else {
                    if (flag === 0) {
                        this.sourceLinkTest(this.dataForm)
                    }
                }
            })
        },
        sourceLinkTest(row) {
            this.$tools
                .asyncPost(
                    this,
                    this.$baseUrl.testConnection, {
                    data: {
                        type: row.type,
                        ip: row.ip,
                        port: row.port,
                        username: row.username,
                        password: row.password,
                    }
                }
                )
                .then((res) => {
                    if (res.data.code == 0) {
                        this.$message({
                            type: 'success',
                            message: res.data.msg
                        })
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.data.msg
                        })
                    }
                })
                .catch((err) => {
                });
        },
        // 取消重制
        handleClose() {
            this.$refs.dataForm.resetFields()
            this.dataForm = {
                id: '',
                name: '',
                type: '1',
                driverClassName: '',
                username: '',
                password: '',
                ip: "",
                port: "",
                description: ''
            }
            this.setDatasourceVisible = false
        },
        // 保存
        submitForm() {
            // mysql 需要包含useOldAliasMetadataBehavior
            // if (this.dataForm.sourceType == 'Mysql') {
            //   if (this.dataForm.url.indexOf('useOldAliasMetadataBehavior') == -1) {
            //     if (this.dataForm.url.indexOf('?') == -1) {
            //       this.dataForm.url = this.dataForm.url + '?useOldAliasMetadataBehavior=true'
            //     } else {
            //       this.dataForm.url = this.dataForm.url + '&useOldAliasMetadataBehavior=true'
            //     }
            //   }
            // }
            this.$refs.dataForm.validate((valid) => {
                if (valid) {
                    if (this.dataForm.id) {
                        delete this.dataForm.deleted
                        delete this.dataForm.ctime
                        delete this.dataForm.utime
                        this.$tools
                            .asyncPost(
                                this,
                                this.$baseUrl.dataSourceedit, {
                                data: {
                                    ...this.dataForm
                                }
                            }
                            )
                            .then((res) => {
                                if (res.data.code == 0) {
                                    if (this.type == 2) {
                                        this.$message({
                                            type: 'success',
                                            message: '配置成功'
                                        })
                                    } else {
                                        this.$message({
                                            type: 'success',
                                            message: '修改成功'
                                        })
                                    }

                                    // 刷新表格
                                    this.$emit('refreshTable')
                                    this.handleClose()
                                }
                            })
                            .catch((err) => {

                            });
                    } else {
                        this.$tools
                            .asyncPost(
                                this,
                                this.$baseUrl.dataSourceadd, {
                                data: {
                                    ...this.dataForm
                                }
                            }
                            )
                            .then((res) => {
                                if (res.data.code == 0) {
                                    this.$message({
                                        type: 'success',
                                        message: '添加成功'
                                    })
                                    // 刷新表格
                                    this.$emit('refreshTable')
                                    this.handleClose()
                                }
                            })
                            .catch((err) => {

                            });
                    }
                } else {
                    return false
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.bselformitem {
    ::v-deep .el-form-item__label {
        width: 65px !important;
    }

    ::v-deep .el-form-item__content {
        margin-left: 65px !important;
    }
}

.bs-el-select {
    width: 100%;
}
</style>
